<div style="width: 100%; height: 100%;">
  <div class="colorBg" class="graph">
    <div class="wrapper">
      <div id="graph-area" #graphArea></div>
      <div class="date-div">{{dateRange}}</div>
    </div>
    <div class="legend-area" *ngIf="!legendDisabled">
      <ul class="legend">
          <li class="legend_item primary-color-border" [ngClass]="{'item_selected': legendItem.selected}"
          (click)="selectLegendItem(legendItem)" *ngFor="let legendItem of legendData">{{legendItem.displayName}}<i *ngIf="legendItem.selected" class="fa fa-caret-left" [ngStyle]="{'font-size':'16px','color':colorPalette.primaryColor}"></i><i *ngIf="!legendItem.selected" class="space"></i></li>
      </ul>
    </div>
    <div class="clearBoth"></div>
  </div>
</div>
